import React from "react";
import Button from "../../components/Button";
import Modal from "../../components/Modal";

const AssayForm = ({ isOpen, onClose, assayData, onChange, onSubmit, isEdit }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={isEdit ? "Update Assay and Weight" : "Add Assay and Weight"}
    >
      <div style={{ padding: "20px 0", minWidth: "400px" }}>
        <div className="flex flex-middle mb-24 mt-10">
          <div className="c-gray mr-4" style={{ minWidth: "120px", fontWeight: "500" }}>
            PT Assay :<span className="c-red">*</span>
          </div>
          <div className="flex-1">
            <input
              type="number"
              value={assayData.ptAssay || ""}
              onChange={(e) => onChange({ ...assayData, ptAssay: e.target.value })}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "4px solid #9ca3af",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "500",
                backgroundColor: "#ffffff",
                color: "#333",
                boxSizing: "border-box",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6b7280";
                e.target.style.boxShadow = "0 0 0 3px rgba(107, 114, 128, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#9ca3af";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>

        <div className="flex flex-middle mb-24 mt-10">
          <div className="c-gray mr-4" style={{ minWidth: "120px", fontWeight: "500" }}>
            PD Assay :<span className="c-red">*</span>
          </div>
          <div className="flex-1">
            <input
              type="number"
              value={assayData.pdAssay || ""}
              onChange={(e) => onChange({ ...assayData, pdAssay: e.target.value })}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "4px solid #9ca3af",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "500",
                backgroundColor: "#ffffff",
                color: "#333",
                boxSizing: "border-box",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6b7280";
                e.target.style.boxShadow = "0 0 0 3px rgba(107, 114, 128, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#9ca3af";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>

        <div className="flex flex-middle mb-24 mt-10">
          <div className="c-gray mr-4" style={{ minWidth: "120px", fontWeight: "500" }}>
            RH Assay :<span className="c-red">*</span>
          </div>
          <div className="flex-1">
            <input
              type="number"
              value={assayData.rhAssay || ""}
              onChange={(e) => onChange({ ...assayData, rhAssay: e.target.value })}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "4px solid #9ca3af",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "500",
                backgroundColor: "#ffffff",
                color: "#333",
                boxSizing: "border-box",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6b7280";
                e.target.style.boxShadow = "0 0 0 3px rgba(107, 114, 128, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#9ca3af";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>

        <div className="flex flex-middle mb-24 mt-10">
          <div className="c-gray mr-4" style={{ minWidth: "120px", fontWeight: "500" }}>
            SUBWEIGHT :<span className="c-red">*</span>
          </div>
          <div className="flex-1">
            <input
              type="number"
              value={assayData.subweight || ""}
              onChange={(e) => onChange({ ...assayData, subweight: e.target.value })}
              style={{
                width: "100%",
                padding: "10px 12px",
                border: "4px solid #9ca3af",
                borderRadius: "6px",
                fontSize: "15px",
                fontWeight: "500",
                backgroundColor: "#ffffff",
                color: "#333",
                boxSizing: "border-box",
              }}
              onFocus={(e) => {
                e.target.style.borderColor = "#6b7280";
                e.target.style.boxShadow = "0 0 0 3px rgba(107, 114, 128, 0.1)";
              }}
              onBlur={(e) => {
                e.target.style.borderColor = "#9ca3af";
                e.target.style.boxShadow = "none";
              }}
            />
          </div>
        </div>

        <div className="flex flex-middle flex-right pt-25" style={{ borderTop: "1px solid #e9ecef" }}>
          <Button
            type="modalCancel"
            className="flex flex-middle ht-40 mr-20 btn btn-red"
            onClick={onClose}
          >
            <span>CANCEL</span>
          </Button>
          <Button
            type="modalSave"
            className="flex ht-40 flex-middle btn"
            onClick={onSubmit}
          >
            <span>SAVE</span>
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default AssayForm;
